import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{ title: string }>;

export const UnauthenticatedLayout = ({ title, children }: Props) => {
	const { t } = useResource();
	const documentTitle = `${title} | ${t(Resources.Common.AppName)}`;

	return (
		<>
			<title>{documentTitle}</title>
			<div className="mt-20 flex flex-col items-center justify-center">
				{children}
			</div>
		</>
	);
};
